<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAdd_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12.5 1h-9A2.5 2.5 0 0 0 1 3.5v9A2.5 2.5 0 0 0 3.5 15h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 12.5 1m-.964 7.75H8.75v2.786a.75.75 0 0 1-1.5 0V8.75H4.464a.75.75 0 0 1 0-1.5H7.25V4.464a.75.75 0 0 1 1.5 0V7.25h2.786a.75.75 0 0 1 0 1.5"
    />
</svg>
